export default __webpack_public_path__ + "static/media/Beaming-and-Offline-FRC.4525afdf.mp4";